import clsx from 'clsx';
import React from 'react';
import { motion } from 'framer-motion';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/material';

import { varSmallClick } from '../../components/Animate';

const useStyles: any = makeStyles(() => ({
  root: {
    display: 'inline-flex'
  }
}));

function ButtonAnimate(props: React.ComponentPropsWithoutRef<typeof Box>) {
  const { children, className, ...other } = props;
  const classes = useStyles();

  return (
    <Box
      component={motion.div}
      whileTap="tap"
      whileHover="hover"
      variants={varSmallClick}
      className={clsx(classes.root, className)}
      {...other}
    >
      {children}
    </Box>
  );
}

export default ButtonAnimate;
